/**
 * A person's name as every surface shows it (ADR 0034): their full name, or
 * "No name yet" until the registrar records one. Nothing stands in for it: not
 * an email, not the login account's name.
 */
export const NO_NAME = "No name yet";

export function personName(fullName: string | null | undefined): string {
  return fullName?.trim() || NO_NAME;
}

/** A person with their honorific, as a directory or a record title names them. */
export function personTitle(fullName: string | null | undefined, honorific: string | null | undefined): string {
  const name = fullName?.trim();
  if (!name) return NO_NAME;
  return honorific ? `${honorific} ${name}` : name;
}

// Diacritics and the ʿayn and hamza marks of transliteration do not order a
// name: ʿAlī files beside Ahmad, Ḥasan beside Hamza.
const UNORDERED = /[\u0300-\u036f\u02be\u02bf\u2018\u2019']/g;
const collator = new Intl.Collator("en", { sensitivity: "base", numeric: true });

/** People by full name, as a reader files them; people with no name yet last. */
export function comparePersonNames(a: string | null | undefined, b: string | null | undefined): number {
  const left = a?.trim();
  const right = b?.trim();
  if (!left || !right) return left ? -1 : right ? 1 : 0;
  return collator.compare(left.normalize("NFD").replace(UNORDERED, ""), right.normalize("NFD").replace(UNORDERED, ""));
}

/**
 * A person among others in a one-line choice: an unnamed person is told apart
 * by their email, the way the People register lists them beside it.
 */
export function personChoice(fullName: string | null | undefined, email: string | null | undefined): string {
  const name = fullName?.trim();
  if (name) return name;
  return email ? `${NO_NAME} · ${email}` : NO_NAME;
}
